import { Box, Button, Modal, Paper } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectLabels } from "../../../slices/language";

interface ExistingUserEmailModalProps {
  open: boolean;
  onClose: () => void;
  email: string;
}

const ExistingUserEmailModal = ({
  open,
  onClose,
  email,
}: ExistingUserEmailModalProps) => {
  const labels = useAppSelector(selectLabels);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          style={{
            maxWidth: 400,
            minWidth: 320,
            width: "40%",
            boxSizing: "border-box",
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 48,
            paddingLeft: 48,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p
            className="body-text-lg font-w-500 title-color"
            style={{ textAlign: "center", marginBottom: 16 }}
          >
            {labels.existing_user_email_title}
          </p>
          <p style={{ textAlign: "center" }}>{labels.existing_user_email_body}</p>
          <p style={{ textAlign: "center", marginTop: 8 }}>
            <span style={{ fontWeight: "bold" }}>{email}</span>
          </p>
          <p style={{ textAlign: "center", marginTop: 16 }}>
            {labels.existing_user_email_footer}
          </p>
          <div className="w-100 flex gap-4 mt-10">
            <Button variant="contained" fullWidth onClick={onClose}>
              {labels.accept}
            </Button>
          </div>
        </Paper>
      </Box>
    </Modal>
  );
};

export default ExistingUserEmailModal;
